export default __webpack_public_path__ + "static/media/FlapWhite_diffuse-min.8886830e.jpg";